import React from 'react';
import { Link } from 'react-router-dom';
import
    { Slider
    , FormGroup
    , Switch
    , Breadcrumbs
} from '@germix/germix-react-core';
import { withTranslation, WithTranslation } from 'react-i18next';

import Application from '../components/app/Application';
import hexToRgb from '../utils/hexToRgb';
import copyToClipboard from '../utils/copyToClipboard';

interface Props extends WithTranslation
{
}
interface State
{
    horzLength,
    vertLength,
    blurRadius,
    spreadRadius,
    opacity,
    shadowColor,
    panelColor,
    backgroundColor,
    inset,
}

/**
 * @author Germán Martínez
 */
class RouteToolBoxShadow extends React.Component<Props,State>
{
    state: State =
    {
        horzLength: 10,
        vertLength: 10,
        blurRadius: 5,
        spreadRadius: 0,
        opacity: 0.5,
        shadowColor: '#000000',
        panelColor: '',
        backgroundColor: '',
        inset: false,
    }
    render()
    {
        const { t } = this.props;
    
        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
            <Link to='/tools/box-shadow'>{t('titles.toolsBoxShadowGenerator')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.toolsBoxShadowGenerator')}</h1>
    </FormGroup>
    <FormGroup>
        <div className="row">
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBoxShadow.horzLengthLabel')}</label>
                        <label className="ml-auto">{this.state.horzLength}px</label>
                    </div>
                    <Slider
                        min={-200}
                        max={+200}
                        value={this.state.horzLength}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            horzLength: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBoxShadow.vertLengthLabel')}</label>
                        <label className="ml-auto">{this.state.vertLength}px</label>
                    </div>
                    <Slider
                        min={-200}
                        max={+200}
                        value={this.state.vertLength}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            vertLength: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBoxShadow.blurRadiusLabel')}</label>
                        <label className="ml-auto">{this.state.blurRadius}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={+200}
                        value={this.state.blurRadius}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            blurRadius: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBoxShadow.spreadRadiusLabel')}</label>
                        <label className="ml-auto">{this.state.spreadRadius}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={+200}
                        value={this.state.spreadRadius}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            spreadRadius: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <label>{ t('toolBoxShadow.shadowColorLabel')}</label>
                    <div>
                    <input
                        type="color"
                        value={this.state.shadowColor}
                        onChange={(e: any) =>
                        {
                            this.setState({
                                shadowColor: e.target.value
                            });
                        }}
                    ></input>
                    </div>
                </FormGroup>
                <FormGroup>
                    <label>{ t('toolBoxShadow.panelColorLabel')}</label>
                    <div>
                    <input
                        type="color"
                        value={this.state.panelColor}
                        onChange={(e: any) =>
                        {
                            this.setState({
                                panelColor: e.target.value
                            });
                        }}
                    ></input>
                    </div>
                </FormGroup>
                <FormGroup>
                    <label>{ t('toolBoxShadow.backgroundColorLabel')}</label>
                    <div>
                    <input
                        type="color"
                        value={this.state.backgroundColor}
                        onChange={(e: any) =>
                        {
                            this.setState({
                                backgroundColor: e.target.value
                            });
                        }}
                    ></input>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBoxShadow.opacityLabel')}</label>
                        <label className="ml-auto">{this.state.opacity}</label>
                    </div>
                    <Slider
                        min={0}
                        max={1}
                        step={0.01}
                        value={this.state.opacity}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            opacity: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label className="mr-1">Outline</label>
                        <Switch checked={this.state.inset} onChange={(checked) =>
                        {
                            this.setState({
                                inset: checked,
                            });
                        }}/>
                        <label className="ml-1">Inset</label>
                    </div>
                </FormGroup>
            </div>
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <input className="form-control" value={this.fullFormatBoxShadow()} readOnly={true} />
                        <span className="mini-button ml-1" onClick={() =>
                        {
                            copyToClipboard(this.fullFormatBoxShadow());
                        }}>
                            <i className="icon-clipboard"></i>
                        </span>
                    </div>
                </FormGroup>
                <div className="simple-test-box-panel" style={{background: this.state.backgroundColor}}>
                    <div style={{
                        boxShadow: this.formatBoxShadow(),
                        background: this.state.panelColor,
                    }}>
                    </div>
                </div>
            </div>
        </div>
    </FormGroup>
</Application>
        );
    }

    private formatBoxShadow()
    {
        const shadowRgb = hexToRgb(this.state.shadowColor);

        return ''
                + (this.state.inset ? 'inset ' : '')    // inset
                + this.state.horzLength + 'px '         // h-offset
                + this.state.vertLength + 'px '         // v-offset
                + this.state.blurRadius + 'px '         // blur
                + this.state.spreadRadius + 'px '       // spread
                + 'rgba('
                    + shadowRgb.r+','
                    + shadowRgb.g+','
                    + shadowRgb.b+','
                    + this.state.opacity+')'             // color
    }

    private fullFormatBoxShadow()
    {
        return 'box-shadow: ' + this.formatBoxShadow() + ';';
    }
};
export default withTranslation('common')(RouteToolBoxShadow);
